import { createAsyncThunk } from '@reduxjs/toolkit';
// Import Axios Admin API (this is where the baseURL is and shared reuqest params are set)
import api from '../../utils/api';
import { setAlert } from '../alerts/actions';

export const list = createAsyncThunk(
  'score-cards/list',
  async (
    params = {
      page: 0,
      limit: 10,
      orderBy: null,
      orderDirection: null,
      filter: null,
      search: null,
    },
  ) => {
    try {
      const page = params.page ? params.page : 0;
      const limit = params.limit ? params.limit : 10;
      const res = await api.get(`/admin/score-cards`, { params });
      console.log(page, limit);
      return { ...res.data, page, limit };
    } catch (error) {
      console.log(error);
    }
  },
);

export const create = createAsyncThunk(
  'score-cards/create',
  async ({ data, navigate }, { dispatch }) => {
    try {
      const res = await api.post('/admin/score-cards', data);
      dispatch(list());
      dispatch(
        setAlert({
          message: 'Step Added successfully',
          alertType: 'success',
        }),
      );
      if (navigate) navigate(`/cms/score cards`);
      return res.data;
    } catch (err) {
      const errors = err.response.data.errors;
      if (errors) {
        errors.forEach((error) =>
          dispatch(setAlert({ message: error.message, alertType: 'error' })),
        );
      }
    }
  },
);

export const get = createAsyncThunk(
  'score-cards/get',
  async (id, { dispatch }) => {
    try {
      const res = await api.get(`/admin/score-cards/${id}`);
      return res.data;
    } catch (err) {
      const errors = err.response.data.errors;
      if (errors) {
        errors.forEach((error) =>
          dispatch(setAlert({ message: error.message, alertType: 'error' })),
        );
      }
    }
  },
);

export const edit = createAsyncThunk(
  'score-cards/edit',
  async ({ id, data, navigate }, { dispatch }) => {
    try {
      console.log(data);
      await api.put(`/admin/score-cards/${id}`, data);
      dispatch(
        setAlert({
          message: 'Step updated successfully',
          alertType: 'success',
        }),
      );
      dispatch(list());
      if (navigate) navigate(`/cms/score cards`);
    } catch (err) {
      const errors = err.response.data.errors;
      if (errors) {
        errors.forEach((error) =>
          dispatch(setAlert({ message: error.message, alertType: 'error' })),
        );
      }
    }
  },
);

export const order = createAsyncThunk(
  'score-cards/order',
  async (data, { dispatch }) => {
    try {
      console.log(data);
      await api.post(`/admin/score-cards/order`, { list: data });
      dispatch(
        setAlert({
          message: 'score-cards order updated successfully',
          alertType: 'success',
        }),
      );
      dispatch(
        list({ page: -1, limit: -1, orderBy: 'order', orderDirection: 'ASC' }),
      );
    } catch (err) {
      const errors = err.response.data.errors;
      if (errors) {
        errors.forEach((error) =>
          dispatch(setAlert({ message: error.message, alertType: 'error' })),
        );
      }
    }
  },
);

export const remove = createAsyncThunk(
  'score-cards/remove',
  async (id, { dispatch }) => {
    try {
      await api.delete(`/admin/score-cards/${id}`);
      dispatch(
        setAlert({
          message: 'Step removed successfully',
          alertType: 'error',
        }),
      );
      dispatch(list());
    } catch (err) {
      const errors = err.response.data.errors;
      if (errors) {
        errors.forEach((error) =>
          dispatch(setAlert({ message: error.message, alertType: 'error' })),
        );
      }
    }
  },
);

export const bulk_remove = createAsyncThunk(
  'score-cards/bulk-remove',
  async ({ data }, { dispatch }) => {
    try {
      await api.post(`/admin/score-cards/delete`, data);
      dispatch(
        setAlert({
          message: 'Steps removed successfully',
          alertType: 'error',
        }),
      );
      dispatch(list());
    } catch (err) {
      const errors = err.response.data.errors;
      if (errors) {
        errors.forEach((error) =>
          dispatch(setAlert({ message: error.message, alertType: 'error' })),
        );
      }
    }
  },
);
